
import { useTranslation } from 'react-i18next';

export default function TeamSection() {
  const { t } = useTranslation();
  
  const teamMembers = [
    {
      name: t('team.roger.name'),
      position: t('team.roger.position'),
      image: "/assets/roger.png",
      bio: t('team.roger.bio'),
      linkedin: "#"
    },
    {
      name: t('team.eveline.name'),
      position: t('team.eveline.position'),
      image: "/assets/eveline.png",
      bio: t('team.eveline.bio'),
      linkedin: "#"
    },
    {
      name: t('team.hasan.name'),
      position: t('team.hasan.position'),
      image: "/assets/hasan.png",
      bio: t('team.hasan.bio'),
      linkedin: "#"
    },
    {
      name: t('team.edmond.name'),
      position: t('team.edmond.position'),
      image: "/assets/edmond.png",
      bio: t('team.edmond.bio'),
      linkedin: "#"
    }
  ];

  return (
    <section id="team" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t('team.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('team.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {teamMembers.map((member, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="aspect-square overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-1">
                  {member.name}
                </h3>
                <p className="text-[#9F7B5B] font-semibold mb-3">
                  {member.position}
                </p>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  {member.bio}
                </p>
                <div className="flex justify-between items-center">
                  <a
                    href={member.linkedin}
                    className="inline-flex items-center text-[#9F7B5B] hover:text-[#8A6B4F] transition-colors cursor-pointer"
                  >
                    <i className="ri-linkedin-fill text-xl mr-2"></i>
                    <span className="text-sm font-medium">{t('common.connect')}</span>
                  </a>
                  <div className="flex space-x-2">
                    <a href="#" className="text-gray-400 hover:text-gray-600 transition-colors cursor-pointer">
                      <i className="ri-mail-line text-lg"></i>
                    </a>
                    <a href="#" className="text-gray-400 hover:text-gray-600 transition-colors cursor-pointer">
                      <i className="ri-twitter-line text-lg"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
